import { useMatches } from 'react-router';

export const useCurrentTabPath = () => {
    const matches = useMatches();
    const currentTabPath =
        matches[matches.length - 1]?.pathname.split('/').pop() || 'overview';

    return currentTabPath;
};
